import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { App } from '@capacitor/app';
import { Keyboard, KeyboardResize } from '@capacitor/keyboard';

export const isNativeApp = () => Capacitor.isNativePlatform();

export const initNativeFeatures = async () => {
  if (!Capacitor.isNativePlatform()) return;

  document.documentElement.classList.add('native-app');

  try {
    // Dark status bar to match the app's dark theme
    await StatusBar.setStyle({ style: Style.Dark });
    if (Capacitor.getPlatform() === 'android') {
      await StatusBar.setBackgroundColor({ color: '#171b24' });
    }
  } catch {}

  try {
    await Keyboard.setResizeMode({ mode: KeyboardResize.Native });
    await Keyboard.setAccessoryBarVisible({ isVisible: true });
  } catch {}

  try {
    // Android hardware back button: go back in history, exit at the root.
    await App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack && window.history.length > 1) {
        window.history.back();
      } else {
        void App.exitApp();
      }
    });
  } catch {}

  try {
    // Hide splash screen after app is ready (auto-show is default)
    await SplashScreen.hide({ fadeOutDuration: 300 });
  } catch {}
};
